import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { connect } from 'react-redux'

import ErrorDialog from 'containers/quickView/ErrorDialog'
import MultiSelectModal from 'containers/quickView/MultiSelectModal'
import QuickViewContainer from 'containers/quickView/QuickViewContainer'
import SpaceModal from 'containers/quickView/SpaceModal'
import UserModal from 'containers/quickView/UserModal'
import InfoModal from 'containers/quickView/InfoModal'
import SignModal from 'containers/quickView/SignModal'
import {
  getActiveSpaceId,
  getActiveUser,
  getInfo,
  getActiveSignId,
  getMultiSelectedSpaces,
} from 'containers/quickView/selectors'
import { getChangeModalPosition } from 'containers/flowPlanner/selectors'
import { getHasClaimOnBehalfPermission } from 'containers/quickView/spaceModal/claimFlow/selectors'

class QuickView extends Component {
  render() {
    const {
      activeSpaceId,
      activeSignId,
      activeUser,
      activeInfo,
      changeModalPosition,
      multiSelectedSpaces,
      hasClaimOnBehalfPermission,
    } = this.props

    const multiSelectIsActive = Object.keys(multiSelectedSpaces).length > 0
    return (
      <QuickViewContainer>
        {multiSelectIsActive && !hasClaimOnBehalfPermission && <ErrorDialog />}
        {multiSelectIsActive && hasClaimOnBehalfPermission && (
          <MultiSelectModal />
        )}
        {activeSpaceId && <SpaceModal id={activeSpaceId} />}
        {activeUser && (
          <UserModal
            user={activeUser}
            changeModalPosition={changeModalPosition}
          />
        )}
        {activeInfo && <InfoModal />}
        {activeSignId && <SignModal id={activeSignId} />}
      </QuickViewContainer>
    )
  }
}

QuickView.propTypes = {
  activeInfo: PropTypes.object,
  activeSignId: PropTypes.number,
  activeSpaceId: PropTypes.number,
  activeUser: PropTypes.object,
  changeModalPosition: PropTypes.object,
  multiSelectedSpaces: PropTypes.object,
  hasClaimOnBehalfPermission: PropTypes.bool,
}

const mapStateToProps = (state) => ({
  activeSpaceId: getActiveSpaceId(state),
  activeUser: getActiveUser(state),
  activeInfo: getInfo(state),
  activeSignId: getActiveSignId(state),
  changeModalPosition: getChangeModalPosition(state),
  multiSelectedSpaces: getMultiSelectedSpaces(state),
  hasClaimOnBehalfPermission: getHasClaimOnBehalfPermission(state),
})

export default connect(mapStateToProps)(QuickView)
